import React from 'react';
import { TFunction } from 'i18next';

export const unsupportedBrowser = (t: TFunction) => (
  <>
    <ul>
      <li
        dangerouslySetInnerHTML={{
          __html: t('editorx.error.old-browsers.install-chrome', {
            link: 'https://www.google.com/intl/en/chrome/',
          }),
        }}
      />
      <li
        dangerouslySetInnerHTML={{
          __html: t('editorx.error.old-browsers.install-firefox', {
            link: 'https://www.mozilla.org/en-US/firefox/new/',
          }),
        }}
      />
      <li
        dangerouslySetInnerHTML={{
          __html: t('editorx.error.old-browsers.install-safari', {
            link: 'https://support.apple.com/en-us/HT204416',
          }),
        }}
      />
      <li
        dangerouslySetInnerHTML={{
          __html: t('editorx.error.old-browsers.install-ie', {
            link:
              'https://www.microsoft.com/en-us/download/internet-explorer.aspx',
          }),
        }}
      />
    </ul>
  </>
);
